import { render } from "./CustomerDetailsForm.html?vue&type=template&id=2327b6cb&scoped=true&external"
import script from "./CustomerDetailsForm.js?vue&type=script&lang=js&external"
export * from "./CustomerDetailsForm.js?vue&type=script&lang=js&external"

import "./CustomerDetailsForm.css?vue&type=style&index=0&id=2327b6cb&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2327b6cb"]])

export default __exports__